import {SVGProps} from 'react';

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M16.21 22.165A10.965 10.965 0 0 1 12 23a10.965 10.965 0 0 1-7.778-3.222A10.968 10.968 0 0 1 1 12a10.967 10.967 0 0 1 3.222-7.778A10.967 10.967 0 0 1 12 1a10.967 10.967 0 0 1 7.778 3.222A10.967 10.967 0 0 1 23 12a10.965 10.965 0 0 1-3.222 7.778 10.968 10.968 0 0 1-3.567 2.387Zm1.497-12.458a1 1 0 0 0-1.414-1.414L11 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6Z"
            clipRule="evenodd"
        />
    </svg>
);

export default CheckIcon;
